"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACSkeletonGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/react-in-jsx-scope */
var ACSkeletonGroup = function (props) {
    var gridColsMap = {
        1: 'grid-cols-1',
        2: 'grid-cols-2',
        3: 'grid-cols-3',
        4: 'grid-cols-4',
        5: 'grid-cols-5',
        6: 'grid-cols-6',
        7: 'grid-cols-7',
        8: 'grid-cols-8',
        9: 'grid-cols-9',
        10: 'grid-cols-10',
        11: 'grid-cols-11',
        12: 'grid-cols-12',
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "w-full grid ".concat(gridColsMap[(props === null || props === void 0 ? void 0 : props.cols) || 4], " md:grid-cols-2 sm:grid-cols-1 gap-2 ").concat((props === null || props === void 0 ? void 0 : props.containerClassName) || ''), children: Array((props === null || props === void 0 ? void 0 : props.total) || 8)
            .fill(0)
            .map(function (_, i) {
            return ((0, jsx_runtime_1.jsx)("div", { className: "apx-ui-shimmer-effect w-full rounded-md h-40 ".concat(props === null || props === void 0 ? void 0 : props.className, " w-full") }, i));
        }) }));
};
exports.ACSkeletonGroup = ACSkeletonGroup;
